import { types } from 'mobx-state-tree';
import { BaseEntity } from './BaseEntity';

export const SendingEventExt = types.compose(
  BaseEntity,
  types.model('SendingEventExt', {
    sendingEventId: types.maybe(types.number),
    sendGridEventId: types.maybe(types.string),
    sendGridMessageId: types.maybe(types.string),
    eventType: types.maybe(types.string),
    recipientMailAddress:types.maybe( types.string),
    sendingId: types.identifierNumber,
    timestamp: types.maybe(types.string),
    type: types.maybe(types.string),
    senderId: types.number,
    recipientId: types.number,
    statusId: types.number,
    messageId: types.number,
    from: types.maybe(types.string),
    sender: types.maybe(types.string),
    replyToList: types.maybe(types.string),
    title: types.string,
    body: types.string,
    messageCreatedOn: types.string,
    messageCreatedBy: types.string,
    messageLastModifiedOn: types.string,
    messageLastModifiedBy: types.string,
    messageType: types.maybe(types.string),
    apbNumber: types.maybe(types.number),
  }),
);
